



















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "ConfirmUpdateInfo",
  components: { BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean, required: true },
    show_caption: { type: Boolean, default: false },
  },
  setup(_, { emit, root }) {
    const handleUpdateInfo = () => {
      emit("close");
      root.$router.push({ name: "profilePayeeInfoEdit" });
    };
    return {
      handleUpdateInfo,
    };
  },
});
